'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./container.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Container(_ref) {
  var elevation = _ref.elevation,
      padding = _ref.padding,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['elevation', 'padding', 'className', 'children']);

  var classes = (0, _classnames2.default)('container', 'container--padding-' + padding, 'container--elevation-' + elevation, className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    children
  );
}

Container.propTypes = {
  elevation: _propTypes2.default.oneOf(['none', '1', '2', '3', '4', '5']),
  padding: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

Container.defaultProps = {
  elevation: '1',
  padding: 'medium'
};

exports.default = Container;